<template>
  <v-dialog
    v-model="dialog"
    content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="headline">Detach File's Confirmation</v-card-title>
      <v-card-text>
        <v-container>
          <alert-message />
          Are you sure will detach this file "{{ item.file.name }}"?
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete">Cancel</v-btn>
        <v-btn class="error" text @click="deleteItemConfirm" :loading="loading"
          >Detach
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage.vue";

export default {
  components: { AlertMessage },
  props: {
    item: Object,
    object: String,
    show: [Boolean, String],
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      currentItem: (state) => state.item,
      alert: (state) => state.alert,
    }),
  },
  watch: {
    show(n, o) {
      this.$store.dispatch("alert/clear");
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n) {
      if (!n) {
        this.closeDelete();
      }
    },
  },
  methods: {
    async deleteAttachments(payload) {
      await this.$store.dispatch(`${this.object}/deleteAttachments`, payload);
    },

    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");
    },

    async deleteItemConfirm() {
      this.loading = true;
      let payload = {
        id: this.item.item.id,
        attachmentIds: [this.item.file.id],
      };

      await this.deleteAttachments(payload);

      if (!this.currentItem.status.error) {
        this.closeDelete();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>